
$('.contacts-header__link').on('click', function(e) {
	e.preventDefault();
	$('.contacts-header__link').removeClass('active');
	$(this).addClass('active');
	var href = $(this).attr('href');
	$('.contact__content').children().addClass('hidden');
	$(href).removeClass('hidden');

})



var props = [];
var mapId = $(document).find('#map');

if (mapId.length > 0) {

	ymaps.ready(function () {

		var myMap = new ymaps.Map("map", {
		    center: [56.32719269, 43.95437311],
		    zoom: 11,
		    controls: ['zoomControl']
		});

		myMap.behaviors.disable('scrollZoom');

		var position = [];

		Object.keys(shops).forEach(function(shopsKey) {
			var shopsData = shops[shopsKey];
			position.push(shopsData.position);
			props.push({
				id: shopsData.id,
				position: shopsData.position,
				image: shopsData.image,
				name: shopsData.name,
				address: shopsData.address,
				hours: shopsData.hours,
				phones: shopsData.phones
			})
		});

		function getInfoTemplate( image, name, address, hours, phones ) {

			function haveImage (image) {
				if (image.length > 0) {
					return `<div class="contacts-card__img">
						<img src="${image}">
						<div class="contacts-card__close contacts-card__close--img"></div>
					</div>`
				} else {
					return `<div class="contacts-card__close"></div>`;
				}
			}

			function phonesArray(phone) {
				if (phone.length > 1) {
					var phoneArray = [];
					for (var i=0; i < phone.length; i++) {

						if (phone[phone.length - 1] == phone[i]) {
							phoneArray.push(phone[i] + '<br>');
						} else {
							phoneArray.push(phone[i]+ ',' + '<br>');
						}
					}

					return phoneArray;
					
				} else {
					return phone
				}
			}


			var template = `
				${haveImage(image)}
				<div class="contacts-card__content">
					<div class="contacts-card__title">
						${name}
					</div>
					<div class="contacts-card__info">
						<svg class="icon" width="20px" height="20px">
							<use xlink:href='#placeholder'/>
						</svg>
						<div class="contacts-card__address">
							${address}
						</div>
					</div>
					<div class="contacts-card__info">
						<svg class="icon" width="16px" height="16px">
							<use xlink:href='#clock'/>
						</svg>
						<div class="contacts-card__time">
							${hours}
						</div>
					</div>
					<a href="tel:${phones}" class="contacts-card__info">
			            <svg class="icon" width="14px" height="14px">
			              <use xlink:href="#call"></use>
			            </svg>
			            <div class="contacts-card__tel">
							${phonesArray(phones).join('')}
						</div>
		          	</a>
				</div>`;

			return template;
		}

		

		var myGeoObjects = [];

		for (var i = 0; i < props.length; i++) {

		  myGeoObjects[i] = new ymaps.GeoObject({
		    geometry: {
		      type: "Point",
		      coordinates: position[i]
		    },
		    properties: {
		    	hideIcon: false,
		        balloonContent: getInfoTemplate(props[i].image, props[i].name, props[i].address, props[i].hours, props[i].phones)
		    }
		  }, {
		  	iconLayout: 'default#image',
	        iconImageHref: '/img/loc-01.svg',
	        iconImageSize: [30, 42]
		  });

		}

		myMap.geoObjects.events.add('click', function (e) {
			var object = e.get('target');
			var listCard = $('.contacts-card');
			var coords = object.geometry.getCoordinates();

			for (var i = 0; i < props.length; i++) {
				if (props[i].position == coords) {
					var id = props[i].id; 
					console.log(props[i].id);
				}
			}

			for (var j = 0; j < listCard.length; j++) {
				var href = $(listCard[j]).attr('href');

				if (href == id) {
					$(listCard).removeClass('active');
					$(listCard[j]).addClass('active');
					
				}
			}		
		})

		$('.contacts-card').on('click', function(e) {
			e.preventDefault();
			var href = $(this).attr('href');

			for (var i = 0; i < props.length; i++) {
				if (props[i].id == href) {
					myGeoObjects[i].balloon.open();
				}
			}

			$('.contacts-card').removeClass('active');
			$(this).toggleClass('active');
		})

		var myClusterer = new ymaps.Clusterer({
			preset: 'islands#pinkClusterIcons'
		});
		myClusterer.add(myGeoObjects);
		myMap.geoObjects.add(myClusterer);
		myGeoObjects[0].balloon.open();

	})

	if ($(window).width() > 767) {
		$('.contacts-map__list-wrapper').mCustomScrollbar();
		$($('.contacts-card')[0]).addClass('active');
	}

	$('.contacts__link-map').on('click', function(){
		var text = $(this).find('.small');
		var map = $('.contacts-map__map');
		var list = $('.contacts-map__list')

		if (map.hasClass('hidden-xs')) {
			map.removeClass('hidden-xs');
			list.addClass('hidden-xs');
			text.html('Показать список');
		} else if (list.hasClass('hidden-xs')) {
			list.removeClass('hidden-xs');
			map.addClass('hidden-xs');
			text.html('Показать на карте');
		}

	})
}


